module.exports = __webpack_public_path__ + "static/media/hw_su_13.a04d5b5b.flv";